import { defineStore } from "pinia"

export const useProjectStore = defineStore("project", () => {
  const projectId = ref()
  const projectNo = ref()
  const projectName = ref()

  return { projectId, projectNo, projectName }
})
